// extracted by mini-css-extract-plugin
export var adjacentSlide = "_qe-9";
export var arrowButtonContainer = "_qe-5";
export var arrowButtonIcon = "_qe-6";
export var carouselArrowButton = "_qe-2";
export var carouselElementContainer = "_qe-1";
export var currentSlide = "_qe-8";
export var left = "_qe-3";
export var otherSlide = "_qe-a";
export var productCarouselContainer = "_qe-0";
export var right = "_qe-4";
export var sliderOverflow = "_qe-7";